module.exports = __webpack_public_path__ + "icons/original/small/small-c2.488e286fbc404fc350cc0e4def122c83.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-c2.png
// module id = gBE2
// module chunks = app